import { useId, useRef } from 'react';
import {
  InputWithLabelWrapper,
  TicketInfoLabel,
  StyledInput,
} from '../TicketInfoField/TicketInfoField.styled';
import { formatDate } from 'src/utils/dateFns/formatDate';

interface RequestedDueDateProps {
  date: string | Date;
}
export const RequestedDueDateField = ({ date }: RequestedDueDateProps) => {
  const inputId = useId();
  const inputRef = useRef<HTMLInputElement>();

  const { month, day, year } = formatDate(new Date(date));
  const displayValue = date ? `${month}/${day}/${year}` : '-';

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current?.blur();
    }
  };

  return (
    <InputWithLabelWrapper>
      <TicketInfoLabel htmlFor={inputId} size="medium">
        Requested due date
      </TicketInfoLabel>
      <StyledInput
        appearance="outline"
        size="medium"
        readOnly
        value={displayValue}
        id={inputId}
        ref={inputRef}
        onFocus={handleFocus}
      />
    </InputWithLabelWrapper>
  );
};
